(() => {
  const media = window.matchMedia('(max-width: 989px)');
  let state;
  function restore() {
    if (!state) return;
    const { drawer, drawerMarker, localization, localizationMarker, slot, source } = state;
    const details = drawer.querySelector('details');
    if (details?.open && typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer(new Event('resize'), details.querySelector('summary'));
    }
    if (drawerMarker.isConnected) drawerMarker.after(drawer);
    if (localization && localizationMarker.isConnected) localizationMarker.after(localization);
    localization?.classList.remove('mobile-drawer-localization');
    source.classList.remove('compact-mobile-header-source');
    document.documentElement.classList.remove('compact-mobile-header-ready');
    slot.remove();
    drawerMarker.remove();
    localizationMarker?.remove();
    state = undefined;
  }
  function mount() {
    if (!media.matches) return restore();
    if (state?.drawer.isConnected) return;
    restore();
    const header = document.querySelector('.header-wrapper > .header');
    const source = document.querySelector('.header-bottom');
    const drawer = source?.querySelector('header-drawer[data-breakpoint]');
    const navigation = drawer?.querySelector('.menu-drawer__navigation-container');
    if (!header || !drawer || !navigation) return;
    const drawerMarker = document.createComment('mobile-menu-position');
    drawer.before(drawerMarker);
    const slot = document.createElement('div');
    slot.className = 'mobile-header-menu-slot';
    header.prepend(slot);
    slot.append(drawer);
    const localization = source.querySelector(':scope > .page-width > .header__localization');
    let localizationMarker;
    if (localization) {
      localizationMarker = document.createComment('mobile-localization-position');
      localization.before(localizationMarker);
      localization.classList.add('mobile-drawer-localization');
      navigation.insertBefore(localization, navigation.querySelector('.mobile-menu-artwork'));
    }
    source.classList.add('compact-mobile-header-source');
    document.documentElement.classList.add('compact-mobile-header-ready');
    state = { drawer, drawerMarker, localization, localizationMarker, slot, source };
  }
  media.addEventListener('change', mount);
  document.addEventListener('shopify:section:unload', restore);
  document.addEventListener('shopify:section:load', mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();

if (!customElements.get('mobile-purchase-bar')) {
  customElements.define('mobile-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 989px)');
      this.update = this.update.bind(this);
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      this.onClick = () => {
        const button = document.getElementById(this.dataset.buttonId);
        const form = button?.form;
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        if (form && !form.reportValidity()) return;
        button.click();
      };
      this.action = this.querySelector('button');
      this.price = this.querySelector('[data-mobile-price]');
      this.action.addEventListener('click', this.onClick);
      this.media.addEventListener('change', this.update);
      this.root = document.getElementById(this.dataset.productId);
      if (this.root) {
        this.observer = new MutationObserver(records => {
          if (records.some(record => !this.contains(record.target))) this.schedule();
        });
        this.observer.observe(this.root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden'] });
      }
      this.update();
    }
    update() {
      const nativeButton = document.getElementById(this.dataset.buttonId);
      const prices = document.getElementById(this.dataset.priceId);
      const selector = prices?.querySelector('.price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular';
      const priceText = prices?.querySelector(selector)?.textContent.trim();
      const label = nativeButton?.querySelector('span:not(.hidden)')?.textContent.trim();
      const ready = Boolean(nativeButton && priceText && label);
      this.hidden = !ready;
      document.body.classList.toggle('mobile-purchase-bar-ready', ready && this.media.matches);
      if (!ready) return;
      if (this.price.textContent !== priceText) this.price.textContent = priceText;
      if (this.action.textContent !== label) this.action.textContent = label;
      this.action.disabled = nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true' || nativeButton.classList.contains('loading');
      const error = this.root?.querySelector('.product-form__error-message');
      const message = error?.textContent.trim();
      if (message && message !== this.lastError && !error.closest('[hidden]')) {
        error.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      this.lastError = message;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.action?.removeEventListener('click', this.onClick);
      this.media?.removeEventListener('change', this.update);
      document.body.classList.remove('mobile-purchase-bar-ready');
    }
  });
}
